export const updateStyleMutation = `
mutation updateStyle($input: updateStyle!) {
    updateStyle(input: $input) {
      id
    }
}
`
